export default angular
    .module('syInputTrim', [])
    /**
     * @ngdoc directive
     * @name syInputTrim.directive:syInputTrim
     * @description
     * Creates a controller to track an entire control value will be trim
     */
    // @ngInject
    .directive('syInputTrim', [
        function () {
            return {
                scope: true,
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, $elem, attrs, ctrl) {
                    var filterSpaces = function (str) {
                        return str.replace(/[\s]/g, '')
                    }
                    ctrl.$parsers.unshift(function (viewValue) {
                        var elem = $elem[0],
                            pos = elem.selectionStart,
                            value = ''

                        if (pos !== viewValue.length) {
                            var valueInit = filterSpaces(viewValue.substring(0, elem.selectionStart))
                            pos = valueInit.length
                        }

                        //I launch the regular expression,
                        // Maybe you prefer parse the rest
                        // Of the substring and concat.

                        value = filterSpaces(viewValue)
                        $elem.val(value)

                        elem.setSelectionRange(pos, pos)

                        ctrl.$setViewValue(value)

                        return value
                    })

                    ctrl.$render = function () {
                        if (ctrl.$viewValue) {
                            ctrl.$setViewValue(filterSpaces(ctrl.$viewValue))
                        }
                    }
                }
            }
        }
    ])

    .directive('syInputZeroPrefix', [
        function () {
            return {
                scope: true,
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, $elem, attrs, ctrl) {
                    var zeroPad = function (num) {
                        if ($('select[name="mobilePrefix"]').val() === '+61') {
                            if (
                                num.toString().length < 10 &&
                                num.toString().indexOf('0') !== 0 &&
                                num.toString().trim() != '' &&
                                (num.toString().charAt(0) === '4' || num.toString().charAt(0) === '5')
                            ) {
                                num = '0' + num.replace(/[\s]/g, '')
                                return num
                            }
                        }
                        return num.replace(/[\s]/g, '')
                    }
                    $elem.bind('blur', function () {
                        ctrl.$viewValue = zeroPad(ctrl.$viewValue, 10)
                        $elem.val(ctrl.$viewValue)
                        ctrl.$setViewValue(ctrl.$viewValue)
                    })
                }
            }
        }
    ])

    .directive('syRemoveSpace', [
        function () {
            return {
                scope: true,
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, $elem, attrs, ctrl) {
                    var filterSpaces = function (str) {
                        return str.replace(/[\s]/g, '')
                    }

                    $elem.bind('blur', function () {
                        ctrl.$viewValue = filterSpaces(ctrl.$viewValue)
                        $elem.val(ctrl.$viewValue)
                        ctrl.$setViewValue(ctrl.$viewValue)
                    })
                }
            }
        }
    ])

    .directive('landlinevalidateNo', [
        '$q',
        function ($q) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ngModel) {
                    var filterSpaces = function (str) {
                        return str.replace(/[\s]/g, '')
                    }

                    ngModel.$asyncValidators.validateNo = function (modelValue, viewValue) {
                        var deferred = $q.defer()
                        viewValue = filterSpaces(viewValue)
                        element.val(viewValue)
                        if (/^[\d]*$/.test(viewValue)) {
                            deferred.resolve()
                        } else {
                            deferred.reject()
                        }
                        return deferred.promise
                    }
                }
            }
        }
    ])

    .directive('mobilevalidateNo', [
        '$q',
        function ($q) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ngModel) {
                    var filterSpaces = function (str) {
                        return str.replace(/[\s]/g, '')
                    }

                    ngModel.$asyncValidators.validateNo = function (modelValue, viewValue) {
                        var deferred = $q.defer()
                        if (viewValue) {
                            viewValue = filterSpaces(viewValue)
                            element.val(viewValue)
                            if ($('select[name="mobilePrefix"]').val() === '+61') {
                                if (/^(04|05)[\d]{8}$/.test(viewValue)) {
                                    deferred.resolve()
                                } else {
                                    deferred.reject()
                                }
                                return deferred.promise
                            }

                            if (/^[ \d ]*$/.test(viewValue)) {
                                deferred.resolve()
                            } else {
                                deferred.reject()
                            }
                        } else {
                            deferred.resolve()
                        }
                        return deferred.promise
                    }
                }
            }
        }
    ])
